/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import 'quasar/dist/quasar.ie.polyfills.js'



import '@quasar/extras/fontawesome-v6/fontawesome-v6.css'

import '@quasar/extras/line-awesome/line-awesome.css'

import '@quasar/extras/roboto-font/roboto-font.css'

import '@quasar/extras/material-icons/material-icons.css'



import '@quasar/extras/animate/fadeIn.css'

import '@quasar/extras/animate/fadeOut.css'


// We load Quasar stylesheet file
import 'quasar/dist/quasar.sass'




import 'src/css/app.scss'

import 'src/css/general.css'

import 'src/css/purple-layout.scss'

import 'src/css/borders.scss'

import 'src/css/gradients.scss'

import 'src/css/webfonts.css'


import Vue from 'vue'
import createApp from './app.js'


import 'app/src-pwa/register-service-worker.js'




import qboot_Bootauth from 'boot/auth'

import qboot_Bootapexcharts from 'boot/apex-charts'

import qboot_Bootfunctions from 'boot/functions'

import qboot_Bootproduct from 'boot/product'

import qboot_Bootrecaptcha3 from 'boot/recaptcha3'

import qboot_Bootnotifydefaults from 'boot/notify-defaults'

import qboot_Bootloadingdefaults from 'boot/loading-defaults'

import qboot_Bootcurrencyformat from 'boot/currency-format'

import qboot_Bootpersiandigits from 'boot/persian-digits'

import qboot_Bootvalidators from 'boot/validators'

import qboot_Booti18n from 'boot/i18n'

import qboot_Bootaxios from 'boot/axios'

import qboot_Bootclipboard from 'boot/clipboard'

import qboot_Bootcustomicons from 'boot/custom-icons'

import qboot_Boottrustpilot from 'boot/trustpilot'

import qboot_Bootnumberformat from 'boot/number-format'

import qboot_Bootstringsplus from 'boot/strings-plus'

import qboot_Bootsentry from 'boot/sentry'

import qboot_Bootsocialsharing from 'boot/social-sharing'

import qboot_Boottimehandler from 'boot/time-handler'

import qboot_Boottooltip from 'boot/tooltip'

import qboot_Bootqrcode from 'boot/qrcode'

import qboot_Bootgeolocation from 'boot/geolocation'











// Needed only for iOS PWAs
if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && window.navigator.standalone) {
  import(/* webpackChunkName: "fastclick"  */ '@quasar/fastclick')
}


const publicPath = `/`


async function start () {
  const { app, store, router } = await createApp()

  

  
  let hasRedirected = false
  const redirect = url => {
    hasRedirected = true
    const normalized = Object(url) === url
      ? router.resolve(url).route.fullPath
      : url

    window.location.href = normalized
  }

  const urlPath = window.location.href.replace(window.location.origin, '')
  const bootFiles = [qboot_Bootauth,qboot_Bootapexcharts,qboot_Bootfunctions,qboot_Bootproduct,qboot_Bootrecaptcha3,qboot_Bootnotifydefaults,qboot_Bootloadingdefaults,qboot_Bootcurrencyformat,qboot_Bootpersiandigits,qboot_Bootvalidators,qboot_Booti18n,qboot_Bootaxios,qboot_Bootclipboard,qboot_Bootcustomicons,qboot_Boottrustpilot,qboot_Bootnumberformat,qboot_Bootstringsplus,qboot_Bootsentry,qboot_Bootsocialsharing,qboot_Boottimehandler,qboot_Boottooltip,qboot_Bootqrcode,qboot_Bootgeolocation]

  for (let i = 0; hasRedirected === false && i < bootFiles.length; i++) {
    if (typeof bootFiles[i] !== 'function') {
      continue
    }

    try {
      await bootFiles[i]({
        app,
        router,
        store,
        Vue,
        ssrContext: null,
        redirect,
        urlPath,
        publicPath
      })
    }
    catch (err) {
      if (err && err.url) {
        window.location.href = err.url
        return
      }

      console.error('[Quasar] boot error:', err)
      return
    }
  }

  if (hasRedirected === true) {
    return
  }
  

  

    

    

    
      new Vue(app)
    

    

    

  

}

start()
